import {makeStyles} from "@material-ui/core"
import {ModernTheme} from "../../../../../theme/modern/tokens"
import {TOUCH_MIN} from "../../../../../theme/modern/touchTargets"

const ACTIONS_HEIGHT = TOUCH_MIN + 8 + 8 + 1;

const ACTIONS_CLEARANCE = ACTIONS_HEIGHT + 8;

export default makeStyles((theme: ModernTheme) => ({

    
    "@global": {
        html: {
            scrollPaddingBottom: `${ACTIONS_CLEARANCE}px`,
        },
    },

    tabs: {
        flex: "none",
        display: "flex",
        gap: "4px",
        padding: "6px 8px",
        background: theme.modern.panel,
        borderBottom: `1px solid ${theme.modern.line}`,
    },
    tab: {
        flex: "1 1 0",
        minWidth: 0,
        border: `1px solid ${theme.modern.line}`,
        borderRadius: 8,
        background: theme.modern.panel2,
        color: theme.modern.ink2,
        font: `600 12px ${theme.modern.sans}`,
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        cursor: "pointer",
        minHeight: TOUCH_MIN,
        padding: "0 8px",
    },
    tab__active: {
        background: theme.modern.accentSoft,
        borderColor: theme.modern.accentLine,
        color: theme.modern.accent,
    },
    panel: {
        display: "flex",
        flexDirection: "column",
        minWidth: 0,
        flex: "1 1 auto",

        "&[hidden]": {display: "none"},
    },
    panel__cards: {
        gap: "7px",
        padding: 7,
        background: theme.modern.bg,
    },
    stage: {
        flex: "none",
        display: "flex",
        flexDirection: "column",
        minWidth: 0,
        borderTop: `1px solid ${theme.modern.line}`,
        background: theme.modern.panel,
    },
    actions: {
        position: "sticky",
        bottom: 0,
        zIndex: 6,
        display: "flex",
        gap: "8px",
        padding: 8,
        background: theme.modern.panel,
        borderTop: `1px solid ${theme.modern.line}`,
    },
    btn: {
        flex: "1 1 0",
        minWidth: 0,
        minHeight: TOUCH_MIN,
        borderRadius: 8,
        border: "1px solid transparent",
        font: `600 13px ${theme.modern.sans}`,
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        gap: "6px",
        cursor: "pointer",

        "& svg": {width: 14, height: 14, flex: "none"},
        "&:active": {filter: "brightness(.94)"},
        "&:disabled": {opacity: .55, cursor: "default"},
    },
    btn__approve: {
        background: theme.modern.ok,
        borderColor: theme.modern.ok,
        color: theme.modern.onAccent,
    },
    btn__approve_next: {
        background: theme.modern.accent,
        borderColor: theme.modern.accent,
        color: theme.modern.onAccent,
    },
}))
